module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-认证.45d42.png";